/**
 * Media Capabilities API Detector
 */

export interface MediaCapabilitiesResult {
  supported: boolean;
}

export async function detectMediaCapabilities(): Promise<MediaCapabilitiesResult> {
  try {
    return {
      supported: !!navigator.mediaCapabilities,
    };
  } catch (error) {
    return {
      supported: false,
    };
  }
}
